<template>
  <div>
    <p v-if="isConnected">We're connected to the server!</p>
    <p>Message from server: "{{socketMessage}}"</p>
    <button @click="pingServer()">Ping Server</button>
    <button @click="logoutPing()">LogoutPing</button>
  </div>
</template>

<script>
import { store } from '../../store.js'	
export default {

  computed: {
    isConnected () {
      return this.$store.state.isConnected
    },

    socketMessage () {
	    return this.$store.state.socketMessage
    }
  },	
  
/*
  data: () => ({
    isConnected: false,
    socketMessage: '' //isConnected ? 'connected':'not connected'
  }),
*/
  
  sockets:{
/*
    connect() {
      // Fired when the socket connects.
      this.$store.state.isConnected = true;
      
      console.log(this);
      
    },

    disconnect() {
      this.$store.state.isConnected = true;
      this.socketMessage = "";
    },


    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data
    },
*/
    
    customEmit(d) {
      this.socketMessage = d	    
    }
    
  },

  methods: {
    pingServer() {
      // Send the "pingServer" event to the server.
      this.$socket.emit('pingServer', 'Ping!')
    },
    logoutPing(){
	    this.$socket.close()
    }
    
  }
}
</script>